var render, staticRenderFns
import script from "./WorkPending.vue?vue&type=script&lang=js&"
export * from "./WorkPending.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8abf08b4",
  null
  
)

export default component.exports